import LegalLayout from "@/components/LegalLayout";

const PRIVACY_EMAIL = "giovannimichael94@hotmail.it";

const Section = ({ n, title, children }) => (
  <section className="mt-10 md:mt-12">
    <h2 className="font-display text-2xl md:text-3xl font-medium tracking-[-0.03em] text-lava">
      <span className="text-terracotta font-mono text-base mr-3">
        {String(n).padStart(2, "0")}
      </span>
      {title}
    </h2>
    <div className="mt-4 space-y-4">{children}</div>
  </section>
);

const CookiePolicy = () => {
  const openPrefs = () => {
    window.dispatchEvent(new CustomEvent("open-cookie-banner"));
  };

  return (
    <LegalLayout
      eyebrow="Informativa cookie"
      title={
        <>
          Cookie Policy.
          <br />
          <span className="font-medium text-olive">Solo l'essenziale.</span>
        </>
      }
      lastUpdate="07 maggio 2026"
      testid="cookie-page"
    >
      <p className="text-lg">
        Questa pagina descrive in modo trasparente l'utilizzo dei cookie da
        parte del sito di Pantelflora S.N.C. ai sensi del Provvedimento del
        Garante Privacy del 10 giugno 2021 ("Linee guida cookie e altri
        strumenti di tracciamento") e del Regolamento (UE) 2016/679.
      </p>

      <Section n={1} title="Cosa sono i cookie">
        <p>
          I cookie sono piccoli file di testo che i siti visitati possono
          inviare al dispositivo dell'utente, dove vengono memorizzati per
          essere ritrasmessi al sito alla visita successiva. Le tecnologie
          assimilabili (es. localStorage) seguono lo stesso principio.
        </p>
      </Section>

      <Section n={2} title="Cookie utilizzati da questo sito">
        <p>
          Il sito utilizza esclusivamente <strong>cookie tecnici</strong>{" "}
          necessari al corretto funzionamento delle pagine e a memorizzare
          la scelta espressa nel banner di consenso. Per questi cookie non è
          richiesto il consenso preventivo dell'utente, ai sensi dell'art.
          122 del Codice Privacy.
        </p>
        <div className="mt-6 border border-lava/15 overflow-x-auto">
          <table className="w-full text-sm font-mono">
            <thead className="bg-paper">
              <tr className="border-b border-lava/15 text-left">
                <th className="px-4 py-3 font-medium">Nome</th>
                <th className="px-4 py-3 font-medium">Tipologia</th>
                <th className="px-4 py-3 font-medium">Finalità</th>
                <th className="px-4 py-3 font-medium">Durata</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-lava/10">
                <td className="px-4 py-3">pantelflora.cookie-consent.v1</td>
                <td className="px-4 py-3">Tecnico (localStorage)</td>
                <td className="px-4 py-3">
                  Memorizzare la preferenza espressa nel banner cookie
                </td>
                <td className="px-4 py-3">Persistente (revocabile)</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Section>

      <Section n={3} title="Cookie di profilazione e di terze parti">
        <p>
          Il sito <strong>non utilizza</strong> cookie di profilazione, cookie
          pubblicitari, pixel di tracciamento o strumenti di analisi
          (es. Google Analytics, Meta Pixel). Non vengono trasferiti dati
          a terzi per finalità di marketing.
        </p>
      </Section>

      <Section n={4} title="Gestione delle preferenze">
        <p>
          Puoi modificare in qualsiasi momento la tua scelta cliccando sul
          pulsante seguente o cancellando il dato dal localStorage del tuo
          browser:
        </p>
        <button
          type="button"
          onClick={openPrefs}
          data-testid="cookie-page-prefs-btn"
          className="mt-3 inline-flex items-center gap-3 bg-lava text-cream hover:bg-olive transition-colors duration-500 px-6 py-3 text-sm tracking-tight font-medium"
        >
          Riapri preferenze cookie
        </button>
        <p className="mt-4">
          La maggior parte dei browser permette inoltre di bloccare o
          eliminare i cookie tramite le impostazioni. Tieni presente che
          disabilitando i cookie tecnici alcune funzioni potrebbero non
          essere disponibili.
        </p>
      </Section>

      <Section n={5} title="Titolare e contatti">
        <p>
          Pantelflora S.N.C.
          <br />
          Via De Amicis, 5 — 91017 Pantelleria (TP), Italia
          <br />
          C.F. / P.IVA: IT01656050810
          <br />
          Email per privacy:{" "}
          <a
            href={`mailto:${PRIVACY_EMAIL}`}
            data-testid="cookie-email-link"
            className="underline underline-offset-2 hover:text-olive"
          >
            {PRIVACY_EMAIL}
          </a>
        </p>
      </Section>
    </LegalLayout>
  );
};

export default CookiePolicy;
